import ModalContainer from "../common/modal_container";

import liceseBanner_pc from "../../_asset/banner/License_pc.png"
import liceseBanner_mo from "../../_asset/banner/License_mo.png"
import { isMobile } from "react-device-detect";

export default function LicenseBannerPopup({popShow, setPopShow}: {popShow: boolean, setPopShow: Function}){
    return (        
        <ModalContainer show={popShow}
                        setShow={setPopShow}
                        closeBtn={true}
                        centered={true}
                        className={'license-banner'}
        >
            <img src={isMobile ? liceseBanner_mo : liceseBanner_pc} alt="" />
        </ModalContainer>
    )
}